/**
 * @typedef {import("./state").DataState} DataState
 */

import defaulState from "./state";

/**
 *
 * @param {DataState} state
 */
function resetState(state) {
  state.history = [];
  state.normalizationResponse = null;
  state.isNormalized = false;
  state.hasPassedDuplicatesCheck = false;
  state.file = null;
  state.fileURL = null;
}

export default {
  /**
   *@param {DataState} state
   *@param {String} stage
   */

  SET_STAGE: (state, stage) => {
    state.stage = stage;
  },

  /**
   *@param {DataState} state
   *@param {File} file
   */
  SET_FILE: (state, file) => {
    state.file = file;
  },

  /**
   *@param {DataState} state
   *@param {String} url
   */
  SET_FILE_URL: (state, url) => {
    state.fileURL = url;
  },
  /**
   *
   * @param {DataState} state
   */
  RESET_STATE: (state) => {
    Object.assign(state, defaulState());
  },
  /**
   *
   * @param {DataState} state
   */
  RESET: (state) => {
    state.record = null;
    state.editting = [];
    resetState(state);
  },
  /**
   *
   * @param {DataState} state
   * @param {Data} data
   */
  SET_DATA: (state, data) => {
    state.editting = [...data.data];
    state.record = data;
    state.history = [];
    state.normalizationResponse = null;
    state.isNormalized = false;
    state.hasPassedDuplicatesCheck = false;
  },
  /**
   *
   * @param {DataState} state
   * @param {Array<Cell>} data
   */
  SET_CELLS(state, data) {
    state.record = {
      data,
      ...state.record,
    };
    state.editting = data;
    resetState(state);
  },
  /**
   *
   * @param {DataState} state
   * @param {Array<Cell>} data
   */
  SET_EDITTING: (state, data) => {
    state.history.push([...state.editting]);
    state.editting = data;
  },

  /**
   *
   * @param {DataState} state
   * @param {(Array<NormalizationEntry|undefined)} data
   */
  SET_NORMALIZATION_RESPONSE: (state, data) => {
    state.normalizationResponse = data;
  },

  /**
   *
   * @param {DataState} state
   * @param {(D_CheckResponse|undefined)} data
   */
  SET_D_CHECK_RESPONSE: (state, data) => {
    state.duplicateCheckResponse = data;
  },

  setDataType: (state, dataType) => {
    state.dataType = dataType;
  },

  /**
   *
   * @param {DataState} state
   * @param {(D_CheckResponse|undefined)} data
   */
  SET_DB_CHECK_RESPONSE: (state, data) => {
    state.DBduplicateCheckResponse = data;
  },

  /**
   *
   * @param {DataState} state
   * @param {Array<Number>} ids
   */
  DELETE_CELLs: (state, ids) => {
    const data = state.record.data.filter((x) => !ids.includes(x.$id));
    state.record = {
      data,
      ...state.record,
    };
    state.editting = data;
    resetState(state);
  },
  /**
   *
   * @param {DataState} state
   * @param {Cell} data
   */
  ADD_CELL: (state, cell) => {
    const data = state.editting.map((x) => x);
    data.push(cell);
    state.editting = data;
  },
  /**
   *
   * @param {DataState} state
   * @param {Boolean} _state
   */
  SET_NORMALIZATION_STATE: (state, _state) => {
    state.isNormalized = _state;
  },
  /**
   *
   * @param {DataState} state
   * @param {Boolean} _state
   */
  SET_DCHECK_STATE: (state, _state) => {
    state.hasPassedDuplicatesCheck = _state;
  },
  /**
   *
   * @param {DataState} state
   * @param {Boolean} _state
   */
  SET_DBCHECK_STATE: (state, _state) => {
    state.hasPassedDBDuplicatesCheck = _state;
  },
  /**
   *
   * @param {DataState} state
   * @param {Array<Record} uploads;

   */
  SET_UPLOADS: (state, uploads) => {
    state.uploads = uploads;
  },
  /**
   *
   * @param {DataState} state
   * @param {Array<Object>} records
   */
  SET_RECORDS: (state, records) => {
    state.records = records;
  },
};
